import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import LandingPage from './components/LandingPage'
import PrivacyPolicyPage from './components/PrivacyPolicy';
import ProfilePage from './components/Profile';
import TermsOfServicePage from './components/TermsOfService';
import ProPage from './components/ProPage';
import AboutPage from './components/AboutPage';
import CompatibilityPage from './components/CompatibilityPage';
import ResearchPage from './components/ResearchPage';
import BlogPage from './components/BlogPage';
import BlogPostPage from './components/BlogPostPage';

// Component to handle deep links
const DeepLinkHandler: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleDeepLink = (url: string) => {
      const path = new URL(url).pathname;
      if (path.startsWith('/profile/')) {
        const username = path.split('/').pop();
        navigate(`/profile/${username}`);
      }
    };

    // Check for initial URL when the app loads
    if (window.location.pathname !== '/') {
      handleDeepLink(window.location.href);
    }

    // Listen for changes to the URL
    const handlePopState = () => {
      handleDeepLink(window.location.href);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  return null;
};

function App() {
  return (
    <Router>
      <DeepLinkHandler />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/profile/:username" element={<ProfilePage />} />
        <Route path="/pro" element={<ProPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/compatibility" element={<CompatibilityPage />} />
        <Route path="/research" element={<ResearchPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
      </Routes>
    </Router>
  )
}

export default App;
